<template>
  <div class="app-container">
    <el-form :inline="true" :model="filters" size="small">
      <el-form-item label="门店">
        <shopSelector v-model="filters.tenant" />
      </el-form-item>
      <el-form-item label="关键字">
        <el-input v-model="filters.search" placeholder="编号/姓名/手机号/备注" clearable />
      </el-form-item>
      <el-form-item label="创建时间">
        <dateOptionSelector :options="dateOptions" v-model="filters.dateTime" :multiple="true" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="queryAll">查询</el-button>
        <el-button type="success" @click="handleCreate">添加回访</el-button>
      </el-form-item>
    </el-form>

    <el-table size="mini" stripe border :data="tableData" highlight-current-row>
      <el-table-column label="测试编号/门店" min-width="150">
        <template slot-scope="scope">
         <div v-if="scope.row.Check">
            {{ scope.row.Check.Code }}
            <el-tag type="info" v-if="scope.row.Check.Tenant">{{ scope.row.Check.Tenant.Name }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="Check.AppointDate" label="测试日期" width="100">
        <template slot-scope="scope">
          {{ format.dateFormat(scope.row.Check.AppointDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="Check.Member.RealName" label="姓名/手机号" width="150">
        <template slot-scope="scope">
          <template>
            {{ scope.row.Check.Member.RealName }}/
           {{ scope.row.Check.Member.Mobile }}
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="Check.Member.Sex" label="性别" width="80">
      </el-table-column>
      <el-table-column prop="Check.Weight" label="体重" width="80">
      </el-table-column>
      <el-table-column prop="Check.Height" label="身高" width="80">
      </el-table-column>
      <el-table-column prop="Check.Member.Channel" label="来源渠道" width="120">
      </el-table-column>
      <el-table-column label="回访日期" width="110">
        <template slot-scope="scope">
          {{ format.dateFormat(scope.row.VisitDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="Description" label="回访备注" min-width="200" show-overflow-tooltip />
      <el-table-column label="创建时间" width="110">
        <template slot-scope="scope">
          {{ format.dateFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleUpdate(scope.row)">修改</el-button>
          <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page.sync="pageIndex"
      />
    </div>

    <visitRecordEditor
      ref="visitRecordEditor"
      :tenant-key="tenantKey"
      @update="queryAll"
    />
  </div>
</template>
<script>
import { getPageList, del } from "@/api/customer/visitRecord";
import visitRecordEditor from "./components/visitRecordEditor.vue";
import shopSelector from "@/components/shopSelector";
import dateOptionSelector from "@/components/dateOptionSelector";
export default {
  components: { visitRecordEditor, shopSelector, dateOptionSelector },
  data() {
    return {
      dateOptions: [{ value: "create", name: "创建时间" }],
      filters: {
        tenant: "",
        search: "",
        dateTime: {
          dateType: "create",
          date: [],
        },
      },
      tableData: [],
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],
    };
  },
  computed: {
    tenantKey() {
      return this.filters.tenant ? this.filters.tenant.Key : "";
    },
  },
  methods: {
    buildQueryParams() {
      return {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        tenant: this.tenantKey,
        search: this.filters.search,
        dateType: this.filters.dateTime.dateType,
        beginDate:
          this.filters.dateTime.date.length > 0 ? this.filters.dateTime.date[0] : "",
        endDate:
          this.filters.dateTime.date.length > 1 ? this.filters.dateTime.date[1] : "",
      };
    },
    queryAll() {
      getPageList(this.buildQueryParams()).then((response) => {
        if (response) {
          this.tableData = response.Items || [];
          this.total = response.Total || this.tableData.length;
        }
      });
    },
    handleCreate() {
      this.$refs.visitRecordEditor.handleCreate();
    },
    handleUpdate(row) {
      this.$refs.visitRecordEditor.handleUpdate(row);
    },
    handleDelete(row) {
      this.$confirm("确认删除该回访记录吗?", "提示", { type: "warning" }).then(() => {
        del({ key: row.Key }).then((response) => {
          if (response) {
            this.msg.successMsg("操作成功");
            this.queryAll();
          }
        });
      });
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = parseInt(val);
      this.$nextTick(() => this.queryAll());
    },
    handleCurrentChange(val) {
      this.pageIndex = parseInt(val);
      this.queryAll();
    },
  },
  mounted() {
    this.queryAll();
  },
};
</script>
